import { HttpClient, HttpMethods } from "../types/httpClient";

function retrieveDocumentKey(httpClient: HttpClient) {
  return (documentId: string) =>
    httpClient.sendHttpRequest<any>({
      endpoint: `/api/documents/${documentId}`,
      method: HttpMethods.GET,
    });
}

export { retrieveDocumentKey };
